import { C } from '../utils/constants';

/**
 * Soft-nudge dialog shown the first time an unfinished-course user lands on
 * /call-day. Pure presentational — onClose / onGoToDay callbacks are handled
 * by the parent (CallDay.jsx), which also owns the localStorage "seen" flag.
 *
 * Overlay + card pattern matches SupportModal.jsx / ChangePasswordModal.jsx.
 */
export const CallDayNudgeModal = ({ onClose, onGoToDay, nextDay }) => {
  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 16,
      }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: '#fff', borderRadius: 16, padding: '32px 28px',
        width: '100%', maxWidth: 480,
        boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
        animation: 'fadeInUp 0.3s ease both',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <h2 style={{
            fontFamily: "'Forum', serif", color: C.brown,
            fontSize: '1.4rem', marginBottom: 4,
          }}>
            Before your call
          </h2>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              background: 'rgba(0,0,0,0.06)', border: 'none', borderRadius: '50%',
              width: 32, height: 32, cursor: 'pointer', fontSize: '1rem',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0, marginLeft: 12,
            }}
          >
            ✕
          </button>
        </div>

        <p style={{
          color: C.text, fontSize: '0.95rem', lineHeight: 1.65,
          marginBottom: 24,
          fontFamily: "'Nunito', sans-serif",
        }}>
          It's recommended you go through the rest of the course before your call day — so if you still have time before your call and haven't completed the course, that's your next step.
        </p>

        <div style={{
          display: 'flex', gap: 10, flexWrap: 'wrap',
        }}>
          <button
            className="btn-primary"
            onClick={() => { onGoToDay(); onClose(); }}
            style={{ flex: '1 1 200px' }}
          >
            Go to Day {nextDay} →
          </button>
          <button
            onClick={onClose}
            style={{
              flex: '1 1 200px',
              background: '#fff',
              border: `1.5px solid ${C.border}`,
              color: C.brown,
              padding: '12px 18px',
              borderRadius: 8,
              fontSize: '0.95rem',
              fontFamily: "'Nunito', sans-serif",
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Watch Call Day video
          </button>
        </div>
      </div>
    </div>
  );
};
